import { EaseBuzzInitiatePaymentLinkDTO } from "../models/EaseBuzzModel";
import { axiosRetryConfig, customAxios } from "./AxiosHttpCommon";

const url = '/EaseBuzz';

function initiatePaymentLinkForMobile(payload: EaseBuzzInitiatePaymentLinkDTO) {
    return customAxios.post(`${url}/InitiatePaymentLinkForMobile`, payload, axiosRetryConfig);
}

export const easeBuzzService = {
    initiatePaymentLinkForMobile
};